export class EstatusEstudio{

    EstatusEstudioID: number;
    Clave : string;
    Nombre: string;
}